import axios from "axios";

// export default axios.create({
//   baseURL: "http://192.168.100.63:8000/api",
// });

export default axios.create({
  baseURL: "https://customer-service-product.com/api",
});
